/* One ticket variant shares seat stock. Contribution codes are shown, never applied automatically. */
(function () {
  'use strict';
  function bookingURL(config, tier, quantity, maximum) {
    const circle = ['circle', 'circle-online'].includes(config.kind);
    if (config.kind && !['circle', 'circle-online', 'craft-night'].includes(config.kind)) throw new Error('this event format is not available. please contact Sofia.');
    const tiers = ['community', 'regular', 'supporter'];
    const limit = config.kind === 'circle-online' ? 99 : circle ? 10 : 16;
    if (!tiers.includes(tier) || !Number.isInteger(quantity) || !Number.isInteger(maximum) || quantity < 1 || quantity > maximum || maximum > limit || !/^\d+$/.test(config.variant)) throw new Error('please check the number of places and contribution.');
    const code = tier === 'community' ? config.communityCode : tier === 'regular' ? config.regularCode : '';
    if (tier !== 'supporter' && !code) throw new Error('this contribution is not available yet. please contact Sofia.');
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart$/.test(config.cartPath)) throw new Error('please contact Sofia for help booking.');
    const properties = {
      'Contribution preference': tier === 'supporter' ? 'supporter' : `${tier} — enter ${code} at checkout; final total shown at checkout`,
      'Event': config.event,
      'When': config.date,
      'Where': config.venue,
      'Cancellation': 'full refund at least 48 hours before; no refund less than 48 hours before' + (circle ? '; full refund if organiser cancels' : '')
    };
    const bytes = new TextEncoder().encode(JSON.stringify(properties));
    const encoded = btoa(Array.from(bytes, byte => String.fromCharCode(byte)).join(''));
    const query = new URLSearchParams({ properties: encoded });
    return `${config.cartPath}/${config.variant}:${quantity}?${query}`;
  }
  function init(root) {
    root.querySelectorAll('[data-native-booking]').forEach(form => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      const button = form.querySelector('[data-booking-submit]');
      button.disabled = form.dataset.ready !== 'true';
      const codePanel = form.querySelector('[data-contribution-code-panel]');
      const codeInput = form.querySelector('[data-contribution-code]');
      const copyButton = form.querySelector('[data-copy-contribution-code]');
      const copyStatus = form.querySelector('[data-copy-status]');
      function updateContribution() {
        const tier = form.elements.contribution.value;
        codePanel.hidden = tier === 'supporter';
        codeInput.value = tier === 'community' ? form.dataset.communityCode : tier === 'regular' ? form.dataset.regularCode : '';
        copyStatus.textContent = '';
      }
      form.addEventListener('change', event => {
        if (event.target.name === 'contribution') updateContribution();
      });
      copyButton.addEventListener('click', async () => {
        const code = codeInput.value;
        try {
          if (!navigator.clipboard?.writeText) throw new Error('clipboard unavailable');
          await navigator.clipboard.writeText(code);
          if (codeInput.value === code) copyStatus.textContent = 'code copied — paste it at checkout.';
        } catch (_) {
          codeInput.focus();
          codeInput.select();
          copyStatus.textContent = 'select and copy the code, then paste it at checkout.';
        }
      });
      updateContribution();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (button.disabled || form.dataset.ready !== 'true' || !form.reportValidity()) return;
        const error = form.querySelector('[role="alert"]');
        try {
          const quantity = form.elements.quantity;
          const url = bookingURL(form.dataset, form.elements.contribution.value, Number(quantity.value), Number(quantity.max));
          error.hidden = true;
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          const encoded = new URL(url, window.location.origin).searchParams.get('properties');
          const properties = JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(encoded), char => char.charCodeAt(0))));
          const response = await fetch(`${form.dataset.cartPath}/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({items: [{id: form.dataset.variant, quantity: Number(quantity.value), properties}]})
          });
          if (!response.ok) {
            const result = await response.json().catch(() => ({}));
            throw new Error(typeof result.description === 'string' ? result.description : 'we could not add these places. please check availability and try again.');
          }
          window.location.assign(form.dataset.cartPath);
        } catch (failure) {
          error.textContent = failure.message;
          error.hidden = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
    });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { bookingURL };
  if (typeof document !== 'undefined') {
    init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
    window.addEventListener('pageshow', () => document.querySelectorAll('[data-native-booking]').forEach(form => { form.querySelector('[data-booking-submit]').disabled = form.dataset.ready !== 'true'; }));
  }
})();
